import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import moment from "jalali-moment";
import axios from "axios";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {doDownloadFile} from "../../utils/DownloadHelper";
import {convertPersianDateToUniversalDate} from "../../utils/TimeConvertor";
import {uploadFile} from "../../service/uploaderService/UploaderService";

export class AccountsListService {
    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
        this.cancelToken = null
    }

    getCashAccountsList(page, fundID, filters, size = 20) {

        if (this.cancelToken) {
            this.cancelToken()
        }

        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/deposit-accounts`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page: page,
                    size: size,
                    ...filters
                }, {},
                {
                    cancelToken: new axios.CancelToken(cancel => this.cancelToken = cancel)
                }
            ).then(resolve)
                .catch(reject)
        })
    }

    addNewAccount(fundID, userId, userCashCode, executorId, userCashAmount, openedAt, userCashActiveState, clearFields, closeDialog) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.post(
            `fund-presentation/funds/${fundID}/members/${userId}/deposit-accounts`,
            prepareCashAccountData(userCashCode, userCashAmount, userCashActiveState, executorId, openedAt),
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            clearFields()
            closeDialog()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "حساب جدید با موفقیت افزوده شد!"))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در ساخت حساب جدید!",
                this.snackbar, this.loading)
        })
    }

    getCashAccountInfo(fundID, accountId) {

        const accountDetail = this.httpClient.get(
            `fund-presentation/funds/${fundID}/deposit-accounts/${accountId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
        )

        /*const loanOffers = this.httpClient.get(
            `fund-presentation/funds/${fundID}/deposit-accounts/${accountId}/loans/offers`,
            this.httpClient.prepareUserAccessHeader(this.token),
        )*/

        const requestList = [accountDetail]

        return new Promise((resolve, reject) => {
            axios.all(requestList)
                .then(axios.spread((accountDetail) => {
                        if (accountDetail.cleared) {
                            resolve({
                                accountStatus: null,
                                accountDetail
                            })
                        } else {
                            this.httpClient.get(`fund-presentation/funds/${fundID}/deposit-accounts/${accountId}/status-details`,
                                this.httpClient.prepareUserAccessHeader(this.token))
                                .then(accountStatus => {
                                    resolve({
                                        accountStatus,
                                        accountDetail
                                    })
                                }).catch(reject)
                        }
                    })
                )
                .catch(reject)
        })

    }

    updateAccountInfo(fundID, accountId, accountData) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${fundID}/deposit-accounts/${accountId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
            accountData
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی اطلاعات حساب با موفقیت انجام شد!"))
            this.loading(setLoadingStateDispatch(false));
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در بروزرسانی اطلاعات حساب!",
                this.snackbar, this.loading)
        })

    }

    clearAccount(fundID, accountId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `fund-presentation/funds/${fundID}/deposit-accounts/${accountId}/clear`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    downloadDepositAccountReports(depositAccountId, reportType) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.getFile(
            `fund-presentation/funds/${this.fundID}/deposit-accounts/${depositAccountId}/reports/${reportType.id}`,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {

            doDownloadFile(response, `گزارش وضعیت حساب ${depositAccountId}`, reportType.type)

            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(
                reason,
                "خطا در دریافت فایل گزارش",
                this.snackbar,
                this.loading
            )
        })
    }

    downloadDepositAccountLoanReports(depositAccountId, reportType) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.getFile(
            `fund-presentation/funds/${this.fundID}/deposit-accounts/${depositAccountId}/loans/reports/${reportType.id}`,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {

            doDownloadFile(response, `گزارش وام های حساب ${depositAccountId}`, reportType.type)

            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(
                reason,
                "خطا در دریافت فایل گزارش",
                this.snackbar,
                this.loading
            )
        })
    }

    getLoanInfo(accountId) {
        const loanOffers = this.httpClient.get(
            `fund-presentation/funds/${this.fundID}/deposit-accounts/${accountId}/loans/offers`,
            this.httpClient.prepareUserAccessHeader(this.token),
        )
        const loanKinds = this.httpClient.get(
            `fund-presentation/funds/${this.fundID}/deposit-accounts/${accountId}/loans/kinds/available`,
            this.httpClient.prepareUserAccessHeader(this.token),
        )

        return new Promise((resolve, reject) => {
            axios.all([loanOffers, loanKinds])
                .then(axios.spread((responseLoanOffers, responseLoanKind) => {
                    resolve({
                        responseLoanOffers,
                        responseLoanKind
                    })
                }))
                .catch(reject)
        })
    }

    getMonthlyDepositOfAccount(fundId, id, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/fund-presentation/funds/${fundId}/monthly-deposits`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    "deposit-account-id": id,
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewMonthlyDeposit(fundID, id, amount, date) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `/fund-presentation/funds/${fundID}/deposit-accounts/${id}/monthly-deposits`,
                {
                    "amount": amount,
                    "depositedAt": convertPersianDateToUniversalDate(date)
                },
                this.httpClient.prepareUserAccessHeader(this.token),
            ).then(resolve).catch(reject)
        })
    }

    getMonthlyDepositOfAccountDetail(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/fund-presentation/funds/${fundID}/monthly-deposits/${id}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    updateNewMonthlyDeposit(fundID, id, amount, date) {

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/fund-presentation/funds/${fundID}/monthly-deposits/${id}`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    depositedAt: convertPersianDateToUniversalDate(date),
                    amount: amount ? amount : "0",
                    enabled: amount && amount.toString().length > 0 && parseInt(amount) !== 0
                }
            ).then(resolve).catch(reject)
        })
    }

    updateMonthlyDepositReceipt(fundID, id, file) {
        return new Promise((resolve, reject) => {
            uploadFile(
                file,
                () => {
                },
                () => {
                },
                () => {
                },
                `/fund-presentation/${fundID}/monthly-deposits/${id}/monthly-deposit-receipts`,
                this.token
            ).then(resolve).catch(reject)
        })
    }
}

function prepareCashAccountData(userCashCode, amount, enabled, executorId, openedAt) {
    return {
        "number": userCashCode,
        "initialBalance": amount.length > 0 ? amount : "0",
        "enabled": enabled,
        "openedAt": moment.from(openedAt, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD'),
        "guardianId": executorId >= 0 ? executorId : null
    }
}


export const AccountStatusType = {
    NORMAL: {
        id: "NORMAL",
        title: "کاربر عادی"
    }, GOOD_DEALER: {
        id: "GOOD_DEALER",
        title: "کاربر خوش حساب"
    }, BAD_DEALER: {
        id: "BAD_DEALER",
        title: "کاربر بدحساب"
    }, BLACK_LIST: {
        id: "BLACK_LIST",
        title: "کاربر لیست سیاه"
    },
}

export function getAccountStatus(status) {
    switch (status) {
        case AccountStatusType.NORMAL.id:
            return AccountStatusType.NORMAL
        case AccountStatusType.BAD_DEALER.id:
            return AccountStatusType.BAD_DEALER
        case AccountStatusType.BLACK_LIST.id:
            return AccountStatusType.BLACK_LIST
        case AccountStatusType.GOOD_DEALER.id:
            return AccountStatusType.GOOD_DEALER
        default:
            return AccountStatusType.NORMAL
    }
}


